import React from "react";
import "./blob.scss";

export const BscBlob = ({
  background,
  children,
  dir,
  name,
  rotateText,
  className,
  width,
  height,
  child,
}) => {
  return (
    <div
      className={`grid-bsc-blob d-flex justify-content-center align-items-center text-white text-center iransansBold ${className}`}
      style={{
        background: children ? 'transparent' : background ? background : '#888',
        zIndex: children ? 0 : 999,
        flexDirection: dir,
        padding: rotateText || children ? 0 : '0 10px',
        width: width ? width : '100%',
        height: height ? height : '55px',
        position: 'relative',
      }}
    >
      {name ? (
        <span
          style={{
            rotate: rotateText ? '90deg' : 0,
            top: rotateText === false ? '35%' : '50%',
            fontSize: rotateText
              ? '20px'
              : rotateText === false
              ? '12px'
              : child && name.length > 9
              ? '11px'
              : child && name.length > 5
              ? '13px'
              : '13px',
          }}
        >
          {name}
        </span>
      ) : (
        ''
      )}
      {children}
    </div>
  );
};
